import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  Box,
  Button,
  Divider,
  IconButton,
  Typography,
  Modal,
  Snackbar,
  Alert,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import ClientHeader from "./ClientHeader";
import InfoTab from "./InfoTab";
import ContactTab from "./ContactTab";
import ZoneTab from "./ZoneTab";
import { useParams, useNavigate, Route, Routes } from "react-router-dom";
import ClientEditAddModal from "../ClientEditAddModal";
import Swal from "sweetalert2";

const serverURL = process.env.REACT_APP_URL;

const tabs = [
  {
    key: "info",
    label: "Info",
  },
  {
    key: "contacts",
    label: "Contacts",
  },
  {
    key: "zones",
    label: "Zones",
  },
];

export default function CompanyView() {
  const { organizationId } = useParams();
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showToast = (message, severity = "success") => {
    setToast({
      open: true,
      message,
      severity,
    });
  };

  const navigate = useNavigate();
  const [openClientModal, setOpenClientModal] = useState(false);
  const [selectedClientDetails, setSelectedClientDetails] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "info";
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedRateCard, setSelectedRateCard] = useState(null);
  const [loading, setLoading] = useState(false);

  const [selectedCompany, setSelectedCompany] = useState(null);
  useEffect(() => {
    if (!organizationId) return;

    getOrganizationDetails();
  }, [organizationId]);
  const getOrganizationDetails = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${serverURL}/organization/view/${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success) {
        setSelectedCompany(response.data);
        // setActiveTab("info");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab) => {
    setSearchParams({
      tab,
    });
  };
  const handleEditClient = (client) => {
    setSelectedClientDetails(client);
    setOpenClientModal(true);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F8F9FB",
        p: 3,
      }}
    >
      <Box
        sx={{
          maxWidth: 1400,
          mx: "auto",
        }}
      >
        {/* Header */}

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 700,
              color: "#2b2b2b",
            }}
          >
            Client Profile
          </Typography>
        </Box>

        {/* Company Header */}

        <ClientHeader organization={selectedCompany?.organizationDetail} />

        {/* Tabs */}

        <Box display="flex" gap={1} mt={3} mb={3}>
          {tabs.map((tab) => {
            const active = activeTab === tab.key;

            return (
              <Button
                key={tab.key}
                disableRipple
                onClick={() => handleTabChange(tab.key)}
                sx={{
                  minWidth: "auto",
                  px: 2,
                  height: 32,
                  borderRadius: "20px",
                  textTransform: "none",
                  fontSize: 12,
                  fontWeight: 400,
                  border: "1px solid #D9D9D9",
                  bgcolor: active ? "#1E1E1E" : "#FFFFFF",
                  color: active ? "#FFFFFF" : "#666",
                  "&:hover": {
                    bgcolor: active ? "#1E1E1E" : "#F4F4F4",
                  },
                }}
              >
                {tab.label}
              </Button>
            );
          })}
        </Box>

        {/* Section Header */}

        <Box display="flex" alignItems="center" mb={3}>
          <Divider sx={{ flex: 1 }} />

          {activeTab === "info" && (
            <Button
              startIcon={<EditOutlinedIcon />}
              onClick={() =>
                navigate(
                  `/adminportal/clientDetails/edit/${organizationId}/details`,
                )
              }
              sx={{
                ml: 2,
                color: "#111c2d",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "12px",
              }}
            >
              Edit Info
            </Button>
          )}

          {activeTab === "contacts" && (
            <Button
              startIcon={<AddOutlinedIcon />}
              onClick={() => {
                setSelectedClientDetails({});
                setOpenClientModal(true);
              }}
              sx={{
                ml: 2,
                color: "#111c2d",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "12px",
              }}
            >
              Add Additional Contact Details
            </Button>
          )}

          {activeTab === "zones" && (
            <Button
              startIcon={<EditOutlinedIcon />}
              onClick={() =>
                navigate(
                  `/adminportal/clientDetails/edit/${organizationId}/zones`,
                )
              }
              sx={{
                ml: 2,
                color: "#111c2d",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "12px",
              }}
            >
              Edit Zones
            </Button>
          )}
        </Box>

        {/* Body */}

        {activeTab === "info" && (
          <InfoTab organization={selectedCompany?.organizationDetail} />
        )}

        {activeTab === "contacts" && (
          <ContactTab
            contacts={selectedCompany?.clientUsers}
            organization={selectedCompany?.organizationDetail}
            onEdit={handleEditClient}
          />
        )}

        {activeTab === "zones" && (
          <ZoneTab regions={selectedCompany?.regions} />
        )}
      </Box>
      <Modal open={openClientModal} onClose={() => setOpenClientModal(false)}>
        <ClientEditAddModal
          open={openClientModal}
          setOpen={setOpenClientModal}
          emailDomain={selectedCompany?.organizationDetail?.domain}
          organizationId={organizationId}
          selectedClientDetails={selectedClientDetails}
          arrayOfClients={selectedCompany?.clientUsers || []}
          setarrayOfClients={(clients) =>
            setSelectedCompany((prev) => ({
              ...prev,
              clientUsers: clients,
            }))
          }
          setselectedCompany={setSelectedCompany}
          updateClientId={selectedClientDetails?._id}
          setAnchorEl={() => {}}
        />
      </Modal>
      {/* <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        fullScreen
        PaperProps={{
          sx: {
            bgcolor: "#F5F7FA",
          },
        }}
      ></Dialog> */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() =>
          setToast((prev) => ({
            ...prev,
            open: false,
          }))
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          onClose={() =>
            setToast((prev) => ({
              ...prev,
              open: false,
            }))
          }
          severity={toast.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
